import {
  PrintProviderError,
  type PrintRequest,
} from "./types";

export function assertCommonPrintPreflight(request: PrintRequest): void {
  const rawOnly = Boolean(request.hardwareActions?.openCashDrawer);
  if (!rawOnly && !request.documentHtml?.trim()) {
    throw new PrintProviderError(
      "INVALID_DOCUMENT",
      "The print document is empty.",
    );
  }
  if (!Number.isInteger(request.copies) || request.copies < 1) {
    throw new PrintProviderError(
      "INVALID_COPIES",
      "Printer copies must be a positive integer.",
    );
  }
  if (!rawOnly && !request.profile.pixelHtml) {
    throw new PrintProviderError(
      "PIXEL_HTML_UNSUPPORTED",
      "The selected tested profile does not support pixel HTML.",
    );
  }
  if (!request.profile.paperWidths.includes(request.paperWidth)) {
    throw new PrintProviderError(
      "WIDTH_UNSUPPORTED",
      `The selected tested profile does not support ${request.paperWidth}.`,
    );
  }
}
export function createSingleUseSend(
  send: (
    options: import("./types").PrintDispatchOptions,
  ) => Promise<import("./types").PrintEvidence>,
): (
  options: import("./types").PrintDispatchOptions,
) => Promise<import("./types").PrintEvidence> {
  let invoked = false;
  return async (options) => {
    if (invoked) {
      throw new PrintProviderError(
        "ALREADY_SENT",
        "A prepared print may only be sent once.",
      );
    }
    invoked = true;
    return await send(options);
  };
}
